import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'
import MaskedInput from '@aytm/lib/rfd-ui/components/basic/masked-input'

import '@aytm/lib/rfd-ui/styles/basic/material-text-field.scss'

export default class MaterialTextField extends TextField {
  static propTypes = {
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    debounce: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    active: PropTypes.bool,
    error: PropTypes.bool,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    onIconClick: PropTypes.func,
    // masking params:
    maskPattern: PropTypes.string,
    maskPlaceholderChar: PropTypes.string,
    maskFormatCharacters: PropTypes.object,
    maskSub: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onMaskedChange = this.onMaskedChange.bind(this)
    if (null == this.state) {
      this.state = {}
    }
    this.state.showLabel = false
    this.maskedEmpty = true
  }

  onFocus(event) {
    super.onFocus(event)
    this.setState({ showLabel: true })
  }

  onBlur(event) {
    super.onBlur(event)
    this.setState({
      showLabel: this.props.maskPattern ? !this.maskedEmpty : Boolean(this.state.value)
    })
  }

  onChange(event) {
    this.maskedEmpty = false
    return super.onChange(event)
  }

  onMaskedChange(newValue, prevValue, data) {
    const r = super.onMaskedChange(newValue, prevValue, data)
    this.maskedEmpty = Boolean(data.empty)
    return r
  }

  componentDidMount() {
    super.componentDidMount()
    const { value, defaultValue, maskPattern } = this.props
    const preFilled = Boolean(value || defaultValue)
    if (maskPattern) {
      this.maskedEmpty = !preFilled
    }
    const { showLabel } = this.state
    if (showLabel != preFilled) {
      this.setState({ showLabel: preFilled })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    super.UNSAFE_componentWillReceiveProps(nextProps)
    if (
      (null != nextProps.value || null != this.props.value) &&
      Boolean(nextProps.value) != Boolean(this.state.showLabel)
    ) {
      this.setState({ showLabel: Boolean(nextProps.value) })
    }
  }

  render() {
    const {
      width,
      icon,
      iconColor,
      active,
      error,
      style,
      className,
      placeholder,
      label,
      readOnly,
      maskPattern,
      maskPlaceholderChar,
      maskFormatCharacters,
      maskSub,
      onFocus,
      onBlur,
      onChange,
      value,
      defaultValue,
      debounce,
      onIconClick,
      ...otherProps
    } = this.props
    const { focused, showLabel, value: sValue } = this.state

    return (
      <div
        className={classNames('rfd-ui-material-text-field', className, {
          'rfd-ui-material-text-field-with-icon': icon,
          'rfd-ui-material-text-field-active': active,
          'rfd-ui-material-text-field-error': error,
          'rfd-ui-material-text-field-focused': focused,
          'rfd-ui-material-text-field-readonly': readOnly
        })}
        style={{ width }}
      >
        <div className="rfd-ui-material-text-field-inner">
          {(label || placeholder) &&
            (showLabel ? (
              <div
                className="rfd-ui-material-text-field-label"
                dangerouslySetInnerHTML={{ __html: label || placeholder }}
              />
            ) : (
              <div className="rfd-ui-material-text-field-label" />
            ))}
          {icon && (
            <i
              className={`rfd-ui-material-text-field-icon ${icon}`}
              style={{
                color: iconColor,
                cursor: onIconClick ? 'pointer' : null
              }}
              onClick={onIconClick}
            />
          )}
          {maskPattern ? (
            <MaskedInput
              className="rfd-ui-material-text-field-input rfd-ui-material-text-field-masked-input"
              pattern={maskPattern}
              placeholderChar={maskPlaceholderChar}
              formatCharacters={maskFormatCharacters}
              sub={maskSub}
              value={sValue}
              placeholder={showLabel ? null : placeholder}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.onMaskedChange}
              ref={this.saveRef('Input')}
              {...otherProps}
            />
          ) : (
            <input
              className="rfd-ui-material-text-field-input"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.onChange}
              value={sValue}
              readOnly={readOnly}
              placeholder={showLabel ? null : placeholder}
              ref={this.saveRef('Input')}
              type="text"
              {...otherProps}
            />
          )}
        </div>
      </div>
    )
  }
}
